import React from 'react';
import { IconProps } from '../types';
const MinecraftSpyglassModel: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="1" height="1" fill="rgba(150, 181, 214, 255)" />
<rect x="1" y="0" width="1" height="1" fill="rgba(191, 212, 235, 255)" />
<rect x="0" y="1" width="1" height="1" fill="rgba(191, 212, 235, 255)" />
<rect x="1" y="1" width="1" height="1" fill="rgba(226, 239, 253, 255)" />
<rect x="0" y="2" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="1" y="2" width="1" height="1" fill="rgba(85, 41, 37, 255)" />
<rect x="0" y="3" width="1" height="1" fill="rgba(160, 81, 17, 255)" />
<rect x="1" y="3" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="0" y="4" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="1" y="4" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="0" y="5" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="1" y="5" width="1" height="1" fill="rgba(85, 41, 37, 255)" />
<rect x="0" y="6" width="1" height="1" fill="rgba(85, 41, 37, 255)" />
<rect x="1" y="6" width="1" height="1" fill="rgba(119, 56, 50, 255)" />
<rect x="0" y="7" width="1" height="1" fill="rgba(119, 56, 50, 255)" />
<rect x="1" y="7" width="1" height="1" fill="rgba(119, 56, 50, 255)" />
<rect x="0" y="8" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="0" y="9" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="0" y="10" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="0" y="11" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="0" y="12" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="0" y="13" width="1" height="1" fill="rgba(150, 181, 214, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(191, 212, 235, 255)" />
<rect x="0" y="14" width="1" height="1" fill="rgba(191, 212, 235, 255)" />
<rect x="1" y="14" width="1" height="1" fill="rgba(226, 239, 253, 255)" />
</svg>);
export default MinecraftSpyglassModel;